import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { PRIORITY_TASK_MENU_ALLOCATION_COUNTS_QUERY } from '../graphql/queries'
import { FETCH_PRIORITY_TASK_MENU_ALLOCATION_COUNTS } from '../redux/action-types'

const usePriorityTaskMenuAllocationCountsQuery = priorityTaskId => {
  const dispatch = useDispatch()

  const {
    priorityTaskMenuAllocationCounts: data,
    isPriorityTaskMenuAllocationCountsLoading: isLoading,
    priorityTaskMenuAllocationCountsError: error,
  } = useSelector(store => store.priorityTasks.priorityTask)

  const fetch = useCallback(
    () =>
      apolloService.query({
        query: PRIORITY_TASK_MENU_ALLOCATION_COUNTS_QUERY,
        variables: {
          priorityTaskId,
        },
        dispatch,
        action: FETCH_PRIORITY_TASK_MENU_ALLOCATION_COUNTS,
      }),
    [dispatch, priorityTaskId],
  )

  useEffect(() => {
    fetch()
  }, [fetch])

  return { isLoading, error, data }
}

export default usePriorityTaskMenuAllocationCountsQuery
